import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { OS } from '../models';
import { map } from 'rxjs/operators';
import { OSSearchParam } from '../models/os-search-param.model';


@Injectable({ providedIn: 'root' })
export class OSService {

  private path = '/operating_systems';

  constructor(private http: AlloxApiService) { }

  public search(param?: OSSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new OS(obj))),
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new OS(obj))
    );
  }
  public post(item: OS) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: OS) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: OS[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }
}
